import React from "react";
import { NavLink } from "react-router-dom";
import "../../style/registerForm.css";

export default function RegisterForm() {
  return (
    <form className="register-form">
      <h1 className="form-title">Welcome, Register</h1>

      <div className="form-row">
        <label>First Name :</label>
        <input type="text" placeholder="First Name" required />
      </div>

      <div className="form-row">
        <label>Last Name :</label>
        <input type="text" placeholder="Last Name" required />
      </div>

      <div className="form-row">
        <label>UserName :</label>
        <input type="text" placeholder="UserName" required />
      </div>

      <div className="form-row">
        <label>Password :</label>
        <input type="password" placeholder="Password" required />
      </div>

      <div className="form-actions">
        <button type="submit" className="btn-primary">
          Register
        </button>

        {/* Navigate back to login */}
        <NavLink to="/automation-testing" className="btn-primary">
          Back to Home
        </NavLink>
      </div>
    </form>
  );
}